module.exports = __webpack_public_path__ + "static/media/HIW_steps_4.c3a3ca5a.jpg";